import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';


export const toastSuccess = (message) =>{
    return toast.success(message, {
      autoClose: 3000,
      theme: "colored",
      style: {
        width: "auto",
        fontSize: "20px"  
  },
    })
  }


export  const toastError = (message) =>{
    return toast.error(message, {
        autoClose: 3000,
        theme: "colored",
        style: {
          width: "auto" ,
          fontSize: "20px" 
  },
    })
  }


export const toastWarning =(message) =>{
    return toast.warn(message, {
      autoClose: 3000,
      theme: "colored",
      style: {
        width: "auto",
        fontSize: "20px"  
  },
    })
  }